$( document ).on('turbolinks:load', () => {
  $('#dte-daily-client-transferred-btn').on('click', () => {
    $('#document-table').addClass('d-none')
    $('.loader').fadeIn();
    $('#daily-document-table').addClass('d-none')
    $('#daily-document-table').find('tbody').html('')
  })
})